<template>
  <div>
    <titleBox name="旷真婚姻家事" imgUrl="../../assets/zhichanBg.jpg"></titleBox>
    <!-- 服务成果 -->
    <div
      class="itemBox"
      style="background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/marriage-01-BG.png);"
      id="chenggou"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/01.png"
          class="numberImg"
          alt=""
        />
        旷真婚姻家事<span class="redColor"></span>
        <i class="redIcon"></i>
      </h2>
      <div class="contentBox">
        <div class="topBox">
          <div class="leftBox" v-for="item in marriageList">
            <span class="num redColor"
              ><countTo
                :startVal="0"
                separator=""
                :endVal="item.number"
                :duration="2000"
                style="margin-right: -0.2rem"
              ></countTo
              >{{item.unit}}</span
            >
            <p class="numTitle">{{item.describe}}</p>
            <p class="numTitle">{{item.remark}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 法律服务产品 -->
    <div class="itemBox" id="chanpin">
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/02.png"
          class="numberImg"
          alt=""
        />
        服务产品
        <i class="redIcon"></i>
      </h2>
      <div v-for="fwcpItem in fwcpList" class="mb-40">
        <h3 class="contenLittleTitle" v-if="fwcpItem.title">
          <div>{{fwcpItem.title}}</div>
          <div class="littleTitle-bottom">
            <div></div>
          </div>
        </h3>
        <p class="contenMsg" v-if="fwcpItem.describe1">{{fwcpItem.describe1}}</p>
        <p class="contenMsg mt-2" v-if="fwcpItem.describe2">{{fwcpItem.describe2}}</p>
        <p class="contenMsg mt-2" v-if="fwcpItem.describe3">{{fwcpItem.describe3}}</p>
      </div>
    </div>
    <!-- 服务特色 -->
    <div
      class="itemBox"
      style="background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/marriage-03-BG.png);"
      id="tese"
    >
      <h2 class="titleBox">
        <img
          src="https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/numberImg/03.png"
          class="numberImg"
          alt=""
        />
        服务特色
        <i class="redIcon"></i>
      </h2>
      <div class="fwts-content">
        <div v-for="fwtsItem in fwtsList" class="fwts-item mb-40">
          <img :src="fwtsItem.img" alt="" />
          <p class="content" v-if="fwtsItem.describe1">{{fwtsItem.describe1}}</p>
          <p class="content mt-20" v-if="fwtsItem.describe2">{{fwtsItem.describe2}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleBox from "../../components/titleBox/index";
import countTo from "vue-count-to";
export default {
  components: { titleBox, countTo },
  data() {
    return {
      marriageList: [
        {
          number: 30,
          unit: "万+",
          describe: "已累计为30万+",
          remark: "客户提供服务",
        },
        {
          number: 5,
          unit: "万+",
          describe: "累计代理家事",
          remark: "客户提供服务",
        },
        {
          number: 3,
          unit: "万+",
          describe: "谈判调解",
          remark: "3万+",
        },
        {
          number: 50,
          unit: "亿",
          describe: "单个案件财产标的额",
          remark: "最高突破50亿元",
        },
        {
          number: 80,
          unit: "%",
          describe: "调解率+",
          remark: "80%",
        },
        {
          number: 90,
          unit: "%",
          describe: "一次离婚率",
          remark: "90%",
        },
        {
          number: 60,
          unit: "天",
          describe: "结案时长",
          remark: "60天",
        }
      ],
      fwcpList: [
        {
          title: "传统婚恋法律服务",
          describe1: "为个人客户在本土恋爱、婚姻家庭事务中提供全面法律支持，涵盖亲密关系的全周期。从恋爱分手纠纷，到婚前财产规划（如婚前协议拟定，明确双方财产归属与权利义务），到婚内纠纷调解，（如处理婚内一方出轨、家暴、赌博等争议），再到离婚诉讼代理，离婚后财产纠纷诉讼代理等，全力维护当事人权益。",
          describe2: "服务对象涵盖在恋爱关系、婚姻关系中面临各种危机和纠纷的人士。",
        },
        {
          title: "涉外家事法律服务",
          describe1: "专注于跨国婚姻家庭法律事务处理。服务内容包括涉外婚姻登记指导，帮助不同国籍人士了解两国婚姻法律要求；处理涉外离婚案件，解决因法律差异带来的复杂问题，如跨国财产分割、子女跨国抚养权与探视权确定等；还提供涉外继承法律事务咨询与代理。服务对象主要是跨国婚姻家庭、涉及海外资产继承的人士。",
        },
        {
          title: "继承与传承法律服务",
          describe1: "继承法律服务专注于处理家庭继承纠纷。传承法律服务致力于生前财富传承规划，为个人和家庭量身定制财富传承方案。",
          describe2: "具体业务涵盖遗嘱咨询、评估、规划、代书、见证；继承纠纷及分家析产诉讼，包括为当事人深入调查遗产范围、厘清继承人范围与继承顺序、提供争议调解、房产评估、房产共有分割、代理继承人参与遗产分割诉讼、强制执行等；以及家族财富管理与传承规划、智慧养老计划等全链条继承家事解决方案。",
          describe3: "服务对象为面临亲人离世后遗产分配困扰的家庭、继承人、遗产管理人，以及具有财富传承意愿的高净值个人、家族企业掌舵人等。",
        }
      ],
      fwtsList: [
        {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/marriage/marriage-03-01.png",
          describe1: "复杂案件",
          describe2: "综合化解"
        },
        {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/marriage/marriage-03-02.png",
          describe1: "调解促和",
          describe2: "体面收场"
        },
        {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/marriage/marriage-03-03.png",
          describe1: "深入精准",
          describe2: "查明财产"
        },
        {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/marriage/marriage-03-04.png",
          describe1: "优质服务",
          describe2: "超值尽享"
        },
        {
          img: "https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/pc/marriage/marriage-03-05.png",
          describe1: "高效响应",
          describe2: "速战速决"
        }
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.redColor {
  color: #ab0000;
}
.itemBox {
  // width: 95%;
  margin: 0rem auto;
  padding: 0 0 0.5rem 0;
  background-color: #fff;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .titleBox {
    width: 95%;
    margin: auto;
    padding-top: 0.5rem;
    margin-bottom: 0.2rem;
    position: relative;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.5rem;

    .numberImg {
      position: relative;
      top: 0.05rem;
      width: 0.5rem;
      height: 0.5rem;
    }
  }
  .contenMsg {
    width: 87%;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 0.2rem;
    line-height: 0.6rem;
    font-size: 0.35rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #666666;
  }
  .contenLittleTitle {
    font-size: 0.4rem;
    text-align: center;
    color: #333333;
    img {
      width: 60%;
    }
    .littleTitle-bottom {
      display: flex;
      justify-content: center;
      margin-top: 0.2rem;
      div {
        width: 1.2rem;
        height: 0.1rem;
        background: #C8050F;
      }
    }
    // line-height: 1rem;
  }
  .mt-2 {
    margin-top: 0.2rem;
  }
  .contentBox {
    width: 100%;
    margin: auto;
    .topBox {
      display: flex;
      margin: 0.3rem auto 0.3rem;
      flex-wrap: wrap;
      padding: 0 0.2rem;
      justify-content: center;
      .leftBox {
        width: 24%;
        text-align: center;
        border-right: 0.06rem dashed #dedede;
      }
      .leftBox:last-child,  .leftBox:nth-child(4){
        border: none;
      }
      .leftBox:nth-child(5),  .leftBox:nth-child(6), .leftBox:nth-child(7){
        margin-top: 0.5rem;
      }
      .rightBox {
        flex: 1;
      }
      .num {
        position: relative;
        font-family: DINAlternate-Bold, DINAlternate;
        font-size: 0.7rem;
        font-weight: 700;
      }
      .numTitle {
        margin: 0;
        color: #999;
        font-size: 0.25rem;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }
  .fwts-content {
    display: flex;
    margin: 0 auto 0.3rem;
    flex-wrap: wrap;
    padding: 0 0.2rem;
    justify-content: center;
    .fwts-item {
      width: 20%;
      height: 2.8rem;
      background-color: #fff;
      text-align: center;
      margin-right: 1rem;
      .content {
        font-weight: bold;
        font-size: 0.32rem;
        color: #333333;
        line-height: 0.2rem;
      }
      img {
        height: 0.7rem;
        margin: 0.3rem 0;
      }
    }
    .fwts-item:last-child,  .fwts-item:nth-child(3){
      margin-right: 0;
    }
    .fwts-item:nth-child(4),  .fwts-item:nth-child(5){
      margin-top: 0.5rem;
    }
  }
  .bigBox {
    width: 90%;
    margin: 0.5rem auto;
    padding-left: 0.4rem;
    box-sizing: border-box;

    .header {
      position: relative;
      width: 100%;
      height: 5rem;
      // background-color: #f7f4f5;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      background-image: url(https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/abuout/itemBG.png);
      .isHot {
        position: absolute;
        left: 0;
        top: 0;
        background-color: #fa6e23;
        padding: 0.05rem 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        border-radius: 0px 0px 6px 0px;
        color: #ffffff;
      }
    }

    .title {
      margin: 0.2rem 0;
      color: #707070;
      font-size: 0.35rem;
      font-weight: 700;
    }

    .msg {
      font-size: 0.3rem;
      color: #666666;
      margin-bottom: 0.1rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .watchMsg {
      color: #999;
      font-size: 0.3rem;
      .redIcon {
        position: relative;
        display: inline-block;
        top: -0.05rem;
        width: 8px;
        height: 7px;
        background-size: 100% 100%;
        background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/redIcon.png);
      }
    }
  }
}

.redIcon {
  position: relative;
  display: inline-block;
  top: -0.25rem;
  width: 10px;
  height: 7px;
  background-size: 100% 100%;
  background-image: url(http://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/redIcon.png);
}
.loadMore {
  padding: 0.3rem 0;
  text-align: center;
}
</style>
